import { APP_NAME } from "../modules/shared/constants/app.constants";
import { ENVIRONMENT } from "../modules/shared/enums/environment.enum";

export const environment = {
  oneTrust: {
    id: "01963468-3c15-7444-930b-ca20a0c48c41",
  },
  auth: {
    connectAuthorize: {
      url: "https://sso.eu.edenred.io/connect/authorize",
      scope: ["uta-merchant-api-mfa", "openid"],
      acr_values: "tenant:mobility-uta-merchants",
    },
    tokenAuthorize: {
      url: "https://sso.eu.edenred.io/connect/token",
    },
    connectLogout: {
      url: "https://sso.eu.edenred.io/connect/endsession",
    },
    clientId: "9c3d075cbbb6412f861848c7a01df273",
    redirectUri: "https://partnerhub.edenred.com",
  },
  url: {
    bffBaseUrl: "https://apisummit.edenred.com/merchant-bff-service",
  },
  survey: {
    env: "prod",
  },
  gtm: {
    containerId: "GTM-PN7LG4JH",
    gtmAuth: "y_jyHg9UicKfRWj2uN2gbw",
    gtmPreview: "env-1",
  },
  unleash: {
    url: "https://unleash-summit.edenred.com/api/frontend",
    clientKey:
      "merchant:production.dbf7555711c4a730d5ddc83ce4066b9e60487b90eb32e36360ed8a94",
    appName: APP_NAME,
    environment: ENVIRONMENT.PRODUCTION,
  },
  exploreVideoUrl:
    "https://ugmmerchantstorep.blob.core.windows.net/videos/PartnerHubDemo.mp4",
};
